import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Tematic } from 'src/app/models/obs/tematic';
import { Tier3 } from 'src/app/models/obs/tier3';

@Injectable({
  providedIn: 'root'
})
export class BridgeService {

  t3: Tier3[];
  dpto: string;
  iddpto: string;
  idT3: number;
  idT1: string;

  // Permite suscribirse a varios componentes a este Subject 
  private enviarDptoSubject = new Subject<string>();
  enviarDptoObservable = this.enviarDptoSubject.asObservable();

  private enviarIdDptoSubject = new Subject<string>();
  enviarIdDptoObservable = this.enviarIdDptoSubject.asObservable();

  private enviarIdSubject = new Subject<number>();
  enviarIdObservable = this.enviarIdSubject.asObservable();

  private enviarIdT1Subject = new Subject<string>();
  enviarIdT1Observable = this.enviarIdT1Subject.asObservable();

  private enviarT3Subject = new Subject<Tier3[]>();
  enviarT3Observable = this.enviarT3Subject.asObservable();

  private selectedSectorIdSubject = new Subject<string | null>();
  selectedSectorId$ = this.selectedSectorIdSubject.asObservable();

  enviarDpto(dpto: string) {
    this.dpto = dpto;
    this.enviarDptoSubject.next(dpto);
  }

  enviarIdDpto(iddpto: string) {
    this.iddpto = iddpto;
    this.enviarDptoSubject.next(iddpto);
  }

  enviarIdT3(idT3: number) {
    this.idT3 = idT3;
    this.enviarIdSubject.next(idT3);
  }

  enviarIdT1(idT1: string) {
    this.idT1 = idT1;
    this.enviarIdT1Subject.next(idT1);
  }

  enviarT3(t3: Tier3[]) {
    this.t3 = t3;
    this.enviarT3Subject.next(t3);
  }

  enviarIdSector(sectorId: string | null) {
    this.selectedSectorIdSubject.next(sectorId);
  }

}
